// FE↔BE correlation (#412). A 32-hex trace_id is rotated per route navigation
// (nav.js) and propagated as X-Cloud-Trace-Context on api-salon calls (axios),
// so a frontend action joins its backend logs under one trace. No imports —
// axios.js imports this; keep it cycle-free.

let currentTraceId = null;

function randomHex(byteLen) {
  const arr = new Uint8Array(byteLen);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

function randomSpanDecimal() {
  // Google's X-Cloud-Trace-Context span id is a decimal unsigned integer.
  const arr = new Uint32Array(2);
  crypto.getRandomValues(arr);
  return ((BigInt(arr[0]) << 32n) | BigInt(arr[1])).toString();
}

export function newTrace() {
  currentTraceId = randomHex(16); // 16 bytes → 32 hex chars
  return currentTraceId;
}

export function getCurrentTraceId() {
  if (!currentTraceId) newTrace();
  return currentTraceId;
}

export function buildTraceHeader() {
  return `${getCurrentTraceId()}/${randomSpanDecimal()};o=1`;
}

export function _resetForTest() {
  currentTraceId = null;
}
